import React, { useEffect, useState } from "react";
import { Element } from "react-scroll";
import Layout from "../components/Layout/Layout";
import About from "../components/Sections/About";
import Testimonials from "../components/Sections/Testimonials";
import Herosection from "../components/Sections/Herosection";
import SectionHeading from "../components/Items/SectionHeading";
import Skills from "../components/Sections/Skills";
import Services from "../components/Sections/Services";
import Experiences from "../components/Sections/Experiences";
import Portfolios from "../components/Sections/Portfolios";
import Contact from "../components/Sections/Contact";
import useMediaQuery from "../hooks/useMediaQuery";
import Blogs from "../components/Sections/Blogs";
// import Funfacts from "../components/Sections/Funfacts";
// import Clients from "../components/Sections/Clients";

function Homepage() {
  const isMobile = useMediaQuery(768);
  const [repos, setRepos] = useState([]);

  async function getApiData() {
    const [prof, repos] = await Promise.all([
      fetch(`https://api.github.com/users/lucasspi`).then((response) =>
        response.json()
      ),
      fetch(`https://api.github.com/users/lucasspi/repos`).then((response) =>
        response.json()
      ),
    ]);
    setRepos(repos);
    console.log("getApiData", { prof, repos });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getApiData();
  }, []);

  const sectionClass = `shadow-blue white-bg ${
    isMobile ? "padding-mobile" : "padding"
  }`;
  return (
    <Layout>
      <Element name="section-home">
        <Herosection />
      </Element>

      <Element name="section-about">
        <section className={sectionClass}>
          <SectionHeading title="About Me" />
          <About />
        </section>
      </Element>

      <Element name="section-skills">
        <section className={sectionClass}>
          <SectionHeading title="My skills" />
          <Skills />
        </section>
      </Element>

      <Element name="section-services">
        <section className={sectionClass}>
          <SectionHeading title="Services" />
          <Services />
        </section>
      </Element>

      <Element name="section-experiences">
        <section className={sectionClass}>
          <SectionHeading title="Main experiences" />
          <Experiences title="Experiences" />
        </section>
      </Element>

      <Element name="section-portfolios">
        <section className={sectionClass}>
          <SectionHeading title="Portfolio" />
          <Portfolios />
        </section>
      </Element>

      <Element name="section-experiences">
        <section className={sectionClass}>
          <SectionHeading title="Academic" />
          <Experiences title="Academic" />
        </section>
      </Element>

      <Element name="section-testimonials">
        <section className={sectionClass}>
          <SectionHeading title="Testimonials" />
          <Testimonials />
        </section>
      </Element>

      {/* <Element name="section-clients">
        <Clients />
      </Element> */}

      <Element name="section-blogs">
        <section className={sectionClass}>
          <SectionHeading title="See my github" />
          <Blogs repos={repos} />
        </section>
      </Element>

      {/* <Element name="section-funfacts">
        <Funfacts />
      </Element> */}
      <Element name="section-contact">
        <section className={sectionClass}>
          <SectionHeading title="Get in touch" />
          <Contact />
        </section>
      </Element>
    </Layout>
  );
}

export default Homepage;
